/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WarehouseLocationViewModel } from '../../models/warehouse-location-view-model';

export interface GetWarehouseLocationsByWarehouse$Params {
  warehouseId: number;
}

export function getWarehouseLocationsByWarehouse(http: HttpClient, rootUrl: string, params: GetWarehouseLocationsByWarehouse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WarehouseLocationViewModel>>> {
  const rb = new RequestBuilder(rootUrl, getWarehouseLocationsByWarehouse.PATH, 'get');
  if (params) {
    rb.path('warehouseId', params.warehouseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WarehouseLocationViewModel>>;
    })
  );
}

getWarehouseLocationsByWarehouse.PATH = '/api/v1/Warehouse/GetWarehouseLocationsByWarehouse/{warehouseId}';
